import type { AppProps } from 'next/app';

import { appWithTranslation, useTranslation } from 'next-i18next';
import TagManager from 'react-gtm-module';

import './../styles/global.scss';
import OldAppbar from '../components/OldAppbar';
import Footer from '../components/Footer';
import React, { useEffect } from 'react';
import Head from 'next/head';
import CookieNotice from "../components/CookieNotice";

const tagManagerArgs = {
  gtmId: 'GTM-K9HJJMQ'
};

// New Google Tag Manager object, needed for GA4, see SDEV-3008 for explanation
const newTagManagerArgs = {
  gtmId: 'GTM-P94VVD4'
};

function MyApp({ Component, pageProps }: AppProps) {
  useEffect(() => {
    TagManager.initialize(newTagManagerArgs);
    TagManager.initialize(tagManagerArgs);

    const urlParams = new URLSearchParams(window.location.search);
    const sbl = urlParams.get('sbl');

    if (sbl) {
      localStorage.setItem('sbl', sbl);
    }
  }, []);

  const { t } = useTranslation('common');

  return (
    <main className="main">
      <Head>
        <title>{t('seo-title')}</title>
        <meta name="description" content={t('seo-description')} />
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="https://sundose-cdn.imgix.net/storefront/images/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="https://sundose-cdn.imgix.net/storefront/images/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="https://sundose-cdn.imgix.net/storefront/images/favicon-16x16.png"
        />

        <div
          dangerouslySetInnerHTML={{
            __html: `
            <!-- Start VWO Async SmartCode -->
    <script type='text/javascript'>
      window._vwo_code = window._vwo_code || (function(){
        var account_id=526899,
          settings_tolerance=2000,
          library_tolerance=2500,
          use_existing_jquery=false,
          is_spa=1,
          hide_element='body',

          /* DO NOT EDIT BELOW THIS LINE */
          f=false,d=document,code={use_existing_jquery:function(){return use_existing_jquery;},library_tolerance:function(){return library_tolerance;},finish:function(){if(!f){f=true;var a=d.getElementById('_vis_opt_path_hides');if(a)a.parentNode.removeChild(a);}},finished:function(){return f;},load:function(a){var b=d.createElement('script');b.src=a;b.type='text/javascript';b.innerText;b.onerror=function(){_vwo_code.finish();};d.getElementsByTagName('head')[0].appendChild(b);},init:function(){
              window.settings_timer=setTimeout(function () {_vwo_code.finish() },settings_tolerance);var a=d.createElement('style'),b=hide_element?hide_element+'{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}':'',h=d.getElementsByTagName('head')[0];a.setAttribute('id','_vis_opt_path_hides');a.setAttribute('type','text/css');if(a.styleSheet)a.styleSheet.cssText=b;else a.appendChild(d.createTextNode(b));h.appendChild(a);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&f='+(+is_spa)+'&r='+Math.random());return settings_timer; }};window._vwo_settings_timer = code.init(); return code; }());
    </script>
    <!-- End VWO Async SmartCode -->
        `
          }}
        />
      </Head>
      <OldAppbar />
      <div className="content">
        <Component {...pageProps} />
      </div>
      <Footer />
      <CookieNotice />
    </main>
  );
}
export default appWithTranslation(MyApp);
